import { Container, type interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { headerServiceModule } from '@/modules/header-service-module';
import { baseModule } from '@/modules/base-module';
import { shareModule } from '@eureka/shared/share-tools/logic';
import { biTrackModule } from '@eureka/domains';
import { saveToProjectModule } from '@eureka/shared/save-to-project/services';
import { agentContainer } from '@/domains/agent';
import { homeContainer } from '@/domains/home';
import { materialContainer } from '@/domains/material';
import { projectContainer } from '@/domains/project';
import { uploadImageContainer } from '@/domains/upload';
import { paymentContainer } from '@/domains/payment';

const container = new Container({
  defaultScope: 'Singleton',
  skipBaseClassChecks: true,
});

container.load(
  baseModule,
  headerServiceModule,
  shareModule,
  biTrackModule,
  saveToProjectModule,
  agentContainer,
  homeContainer,
  materialContainer,
  uploadImageContainer,
  projectContainer,
  paymentContainer,
);

export function rebind(serviceIdentifier: interfaces.ServiceIdentifier<unknown>) {
  if (container.isBound(serviceIdentifier)) {
    container.unbind(serviceIdentifier);
  }
  return container.bind(serviceIdentifier);
}

export { container };
